<template>
  <div class="examList">
    <div class="sub-box">
      <a @click="close" class="btn-return">&lt; 返回</a>
      <div class="examlist-body">
        <!-- 广告位 -->
        <div class="ads" v-if="consultantAdv.image">
          <a v-if="consultantAdv.url !='#'" :href="consultantAdv.url">
            <img :src="consultantAdv.image" alt />
          </a>
          <img v-else :src="consultantAdv.image" alt />
        </div>
        <h2 class="list-tit">国际教育大咖</h2>
        <div class="examlist-con">
          <ul class="countrylist">
            <li :class="{ active: item.id == countryIndex }" v-for="(item, index) in countryList" :key="index" @click="countryIndex = item.id">
              {{ item.name }}
            </li>
          </ul>
          <div class="examList-hid">
            <div class="exam-item" v-for="(item,index) in itemlist" :key="index">
              <dl class="fix">
                <dt>
                  <img :src="item.head" alt />
                  <button v-if="status<=2 && !isMake" class="btn1" @click="tips(item)">立即规划</button>
                  <button v-if="status<=2 && isMake" class="btn2" @click="tips(item)">预约成功</button>
                  <button v-if="status>2" class="btn3">活动结束</button>
                </dt>
                <dd>
                  <h5>{{item.name}}</h5>
                  <b>{{item.position}}</b>
                  <p class="ofw-hide-5">{{item.introduction}}</p>
                </dd>
              </dl>
            </div>

            <img class="loading" src="@/assets/images/loading.gif" v-if="loading" alt />
          </div>
        </div>
      </div>

    </div>

    <Modal @appointment="appointment" @closeModal="modalType = -1" :type="modalType" :msg="modalmsg" :title="modaltitle" />
    <!-- 底部导航 -->
    <Footer style="margin-bottom:0" />
    <!-- 登录弹窗 -->
    <Login v-if="isShowLogin" @closeLogin="isShowLogin = false" @success="loginSuccess" />
  </div>
</template>

<script>
import Login from "../components/login.vue";
import Footer from "../components/footer.vue";
import Modal from "@/components/modal.vue";
import {
  getAdv, //广告
  getExpoInfo, //活动信息
  userLoginStatus, //登录信息
  getUpsTeacher, //大咖列表
  teacherSubscribe, //预约大咖
  checkTeacherSubscribe, //判断用户是否预约大咖
  getIpToCity, //IP定位
} from "@/api/home";
export default {
  components: { Footer, Login, Modal },
  data() {
    return {
      isLogin: false, //是否登录
      isShowLogin: false, //登录框是否展示
      modalType: -1,
      modalmsg: "",
      modaltitle: "",
      cityName: "", //城市名称
      consultantAdv: {
        image: "",
        url: "",
      }, // 顾问列表页广告
      expoId: 0, // 全局活动id
      status: 0, //预约时间状态
      loading: true, //列表加载框
      id: 0, //预约院校嘉宾id
      countryList: [
        { name: "英国", id: "39" },
        { name: "美国", id: "40" },
        { name: "澳大利亚/新西兰", id: "41" },
        { name: "加拿大", id: "42" },
        { name: "欧洲", id: "43" },
        { name: "亚洲", id: "44" },
        { name: "学府", id: "45" },
        { name: "出国考试", id: "46" },
      ],
      countryIndex: "39",
      dataList: [],
      dataitem: null,
      isMake: false,
    };
  },
  computed: {
    itemlist: {
      get: function () {
        if (this.dataList.length > 0) {
          return this.dataList.filter((item) => item.id == this.countryIndex)[0]
            .teachers;
        }
        return [];
      },
    },
  },
  methods: {
    // 登录成功后触发
    loginSuccess() {
      // console.log("登录成功");
      this.isShowLogin = false;
      this.isLogin = true;
      this.appointment();
    },

    // 判断用户是否预约大咖
    async checkTeacherSubscribe(item) {
      let res = await checkTeacherSubscribe({
        expoId: this.expoId,
        upsId: item.upsId,
        teacherId: item.teacherId,
      });
      if (res.succ) {
        this.isMake = true;
      }
    },

    //获取大咖列表
    async getUpsTeacher() {
      let res = await getUpsTeacher({
        params: {
          expoId: this.expoId,
        },
      });
      if (res.succ) {
        this.dataList = res.results;
        //this.upsTeacherList = res.results[0].teachers;
        this.status = res.results[0].subscribeStatus;
        this.loading = false;
        this.checkTeacherSubscribe(res.results[0].teachers[0]);
      }
    },

    // 点击弹出预约提示框
    tips(dt) {
      this.dataitem = dt;
      if (!this.isLogin) {
        this.isShowLogin = true;
        return;
      }
      if (this.isMake) {
        this.modalType = 2;
        this.modaltitle = "请勿重复预约";
        this.modalmsg =
          "您已经成功预约了一个大咖咨询服务，<br>不能重复预约，祝您咨询愉快。";
      } else {
        this.modalType = 0;
        this.modalmsg =
          "大咖预约只能预约一位，<br>预约后不可修改，请您进行确认?";
      }
    },

    async appointment() {
      const { code, succ } = await teacherSubscribe({
        expoId: this.expoId,
        upsId: this.dataitem.upsId,
        teacherId: this.dataitem.teacherId,
      });
      this.isShowModal = true;
      if (succ) {
        this.modalType = 1;
        this.modaltitle = "您已成功预约";
        this.modalmsg =
          "您已提交申请，<br>我们的工作人员会尽快与您联系，请保持电话畅通。";
        this.isMake = true;
      } else {
        this.modalType = 2;
        this.modaltitle = "请勿重复预约";
        this.modalmsg =
          "您已经成功预约了一个大咖咨询服务，<br>不能重复预约，祝您咨询愉快。";
      }
    },

    // 获取活动expoId、adviserStatus
    async getActivityInfo() {
      const res = await getExpoInfo({
        params: {
          name: "expo_science_engineering_202011_m",
        },
      });
      if (res.succ) {
        const { expoId } = res.results;
        this.expoId = Number(expoId);
      }
    },

    // 获取广告
    async getAdv() {
      const res = await getAdv({
        params: {
          expoId: this.expoId,
          city: this.cityName,
        },
      });
      console.log(res);
      if (res.succ) {
        this.consultantAdv =
          res.results.find((item) => item.tag == "yd_sub") || "";
      }
    },

    // 判断用户是否已经登录
    async userIsLogin() {
      let { succ } = await userLoginStatus();
      this.isLogin = succ;
    },

    //定位
    async getCurCity() {
      this.cityName = localStorage.getItem("cityName");
      if (!this.cityName) {
        let res = await getIpToCity();
        if (res.succ) {
          this.cityName = res.results;
          this.getAdv();
        }
      }
    },

    //返回
    close() {
      if (window.location.hostname == "m.eicchannel.com") {
        window.location.href = "http://m.eicchannel.com/special/expo_science_engineering_202011_m/#expert";
      } else if (window.location.hostname == "m0.eicchannel.com") {
        window.location.href = "http://m0.eicchannel.com/special/expo_science_engineering_202011_m/#expert";
      } else {
        this.$router.go(-1);
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
    this.userIsLogin();
    this.getActivityInfo();
    this.getCurCity();
  },
  watch: {
    expoId(newVal) {
      if (newVal) {
        this.getUpsTeacher();
        this.getAdv();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.examList {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: url(~@/assets/images/schoollist_head.png) no-repeat;
  background-size: 100% auto;
  .sub-box {
    padding: 0.3rem 0.3rem 0;
    min-height: 100%;
    .btn-return {
      display: block;
      width: 0.98rem;
      height: 0.37rem;
      line-height: 0.36rem;
      text-align: center;
      background-color: #5b656c;
      color: #fff;
      font-weight: 400;
      font-size: 0.22rem;
      border-radius: 3rem;
      margin-bottom: 0.3rem;
    }
    .examlist-body {
      background: #cee6fb;
      border-radius: 0.2rem;
      padding: 0.23rem 0.2rem;
      margin-bottom: 1.2rem;
      .ads {
        border-radius: 0.2rem;
        overflow: hidden;
        //border: 0.06rem solid #6493ff;
        height: 1.4rem;
        margin-bottom: 0.2rem;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .list-tit {
        font-size: 0.38rem;
        font-family: FZLanTingYuanS-DB1-GB;
        font-weight: 400;
        color: #333c3f;
        line-height: 0.8rem;
        text-align: center;
      }

      .examlist-con {
        border-radius: 0.2rem;
        overflow: hidden;
        position: relative;
        background: #d5eafc;
        .countrylist {
          background: #465da5;
          padding: 0.2rem 0.19rem;
          display: inline-block;
          align-content: center;
          justify-content: center;
          li {
            display: inline-block;
            font-size: 0.24rem;
            font-family: FZLanTingYuanS-DB1-GB;
            font-weight: 400;
            color: #fff;
            margin: 0.02rem 0.2rem;
          }
          .active {
            color: #f9e068;
            border-bottom: 0.05rem solid #f9e068;
          }
        }

        .examList-hid {
          background: #fff;
          padding: 0.2rem 0.2rem 0.1rem 0.3rem;
          position: relative;
          min-height: 5rem;
          //margin-top: 2.6rem;
          dl {
            padding: 0.35rem 0;
            border-bottom: 1px solid #ebf0f9;
            dt {
              width: 1.5rem;
              float: left;
              margin: 0 0.4rem 0.1rem 0;
              img {
                display: block;
                background: #f0f3f7;
                border-radius: 0.1rem;
                overflow: hidden;
              }
              button {
                width: 1.46rem;
                height: 0.37rem;
                border: 0;
                border-radius: 0.19rem;
                font-size: 0.22rem;
                font-weight: 500;
                display: block;
                color: #fff;
                padding-bottom: 0.02rem;
                outline: none;
                &.btn1 {
                  background-color: #de675d;
                }
                &.btn2 {
                  background-color: #116dc1;
                }
                &.btn3 {
                  background-color: #a1a1a1;
                }
              }
            }
            dd {
              width: 4.08rem;
              float: left;
              position: relative;
              h5 {
                border-left: 0.03rem solid #ff6368;
                padding-left: 0.09rem;
                margin-left: -0.1rem;
                font-size: 0.28rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333c3f;
              }
              b {
                padding-bottom: 0.06rem;
                padding-right: 0.4rem;
                font-size: 0.24rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333c3f;
                border-bottom: 1px solid #ebf0f9;
              }
              p {
                font-size: 0.22rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #5e5e5e;
                line-height: 0.28rem;
                margin-top: 0.18rem;
              }
            }
          }
          .loading {
            width: 2rem;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
          }
        }
      }

      .btn-teacher-yy {
        width: 2.8rem;
        height: 0.85rem;
        line-height: 0.85rem;
        text-align: center;
        background-color: #ff6368;
        border-radius: 2rem;
        box-shadow: 0 0.05rem 0 0 #d66569;
        color: #fff;
        font-weight: 900;
        position: fixed;
        bottom: 10%;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 99;
      }
    }
  }
}

.tc {
  width: 6.2rem;
  height: 3.58rem;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  padding: 0.1rem 0.3rem 0;
  border-radius: 0.2rem;
  text-align: center;
}
.examList .tc .qycj_succ_dh {
  width: 0.78rem;
  height: 0.78rem;
  display: block;
  margin: 0 auto 0.24rem;
}
.examList .tc h4 {
  font-size: 0.28rem;
  font-weight: 700;
}
.examList .tc h6 {
  font-size: 0.22rem;
  padding: 0.1rem 0 0.3rem;
}
.examList .tc p {
  font-size: 0.3rem;
  padding-top: 0.1rem;
  color: #0475df;
}
.examList .tc .btn-qd {
  width: 1.6rem;
  height: 0.44rem;
  display: block;
  margin: 0 auto;
  background: #0475df;
  color: #fff;
  font-size: 0.24rem;
  text-align: center;
  line-height: 0.44rem;
  border-radius: 0.22rem;
}

.project-tc-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.project-tc {
  width: 6.1rem;
  height: 4.3rem;
  background: #fff;
  border-radius: 0.12rem;
  text-align: center;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 0 0.6rem;
}
.project-tc h3 {
  font-size: 18px;
  font-weight: 900;
}
.project-tc span {
  width: 0.4rem;
  height: 0.4rem;
  background: url(~@/assets/images/pop_close_btn.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  cursor: pointer;
}
.project-tc button {
  display: block;
  border: 0;
  width: 2.54rem;
  height: 0.52rem;
  line-height: 0.52rem;
  text-align: center;
  border-radius: 0.26rem;
  font-size: 0.24rem;
  font-weight: 700;
  color: #fff;
  background: #0475df;
  margin: 0.2rem auto 0.4rem;
}
.project-tc ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  font-size: 0.28rem;
  margin-top: 0.54rem;
}
.project-tc ul li {
  width: 1.5rem;
  height: 0.6rem;
  line-height: 0.6rem;
  background: #f2f5f7;
  margin-bottom: 0.25rem;
  border-radius: 0.05rem;
  cursor: pointer;
  color: #474d60;
}
.project-tc ul li.active {
  background: #42b9c8;
  color: #fff;
}
.project-tc p {
  font-size: 0.2rem;
  color: #7f838f;
  padding: 0.2rem 0;
}
</style>
